import Calendar from "./core/presentation/components/Calendar";

function App() {
  return (
    <div>
      <Calendar />
    </div>
  );
}

export default App;
